<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/utils/utils'

const props = defineProps<{
  class?: HTMLAttributes['class'],
  style?: HTMLAttributes['style'],
}>()
</script>

<template>
  <tr
    data-slot="table-row"
    :class="cn('hover:bg-muted/50 data-[state=selected]:bg-muted transition-colors', props.class)"
    :style="props.style"
  >
    <slot />
  </tr>
</template>
